import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router, RouterLink, RouterOutlet } from '@angular/router';
import { HxProductInfoService, ProductInfoModel, uiLabel } from 'hx-services';
import { UntypedFormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzTabComponent, NzTabDirective, NzTabLinkDirective, NzTabLinkTemplateDirective, NzTabSetComponent } from 'ng-zorro-antd/tabs';
import { ProductDefinitionEditComponent } from '../edit/product-definition-edit.component';
import { ProductDefSplitListComponent } from '../split/list/product-def-split-list.component';
import { ProductMediaTabComponent } from '../edit/media/product-media-tab.component';

@Component({
    selector: 'hc-product-definition-tab',
    templateUrl: './product-definition-tab.component.html',
    styleUrls: ['./product-definition-tab.component.less'],
    imports: [NgIf, NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzTabSetComponent, NzTabComponent, NzTabDirective, NzTabLinkTemplateDirective, NzTabLinkDirective, RouterLink, ProductDefinitionEditComponent, ProductDefSplitListComponent, ProductMediaTabComponent, RouterOutlet, TranslocoPipe]
})
export class ProductDefinitionTabComponent implements OnInit, OnDestroy {
  model!: ProductInfoModel;
  isEdit = false;
  isCreate = false;
  breadcrumb?: string;
  private $destroyed = new Subject<void>();

  constructor(
    protected aRoute: ActivatedRoute,
    protected fb: UntypedFormBuilder,
    protected productService: HxProductInfoService,
    protected router: Router,
    protected modal: NzModalService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
  ) {
  }

  ngOnInit(): void {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['productDef'] as ProductInfoModel;
    if (this.model) {
      this.isEdit = true;
      this.breadcrumb = uiLabel(this.tr.getActiveLang(), this.model.title);
    } else {
      this.model = {} as ProductInfoModel;
      this.isCreate = true;
    }
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed)).subscribe(paramMap => {
      if (!paramMap.has('tab')) {
        this.router.navigate([], {
          relativeTo: this.aRoute,
          queryParams: {
            tab: 'main',
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
